// extracted by mini-css-extract-plugin
module.exports = {"container":"FileBrowser_container__17vjo","actionBar":"FileBrowser_actionBar__1MzoP","padded":"FileBrowser_padded__1IRXO","newFileContainer":"FileBrowser_newFileContainer__1-Wae"};